import Axios from "axios";
import {config} from "@/config";

Axios.defaults.baseURL = config.apiUrl;
Axios.defaults.headers.common['Content-Type'] = 'application/json';

export default Axios